<template>
    <div class="introduction">
        <layout>
            <template slot="content">
                <img src="@/assets/images/product/banner.png" class="contentImg"/>
                <img src="@/assets/images/product/content1.jpg" class="contentImg"/>
                <img src="@/assets/images/product/content2.jpg" class="contentImg"/>
                <img src="@/assets/images/product/content3.jpg" class="contentImg"/>
            </template>
        </layout>
    </div>
</template>

<script>
import Layout from '@/components/Layout/index.vue'
export default {
    name:'introduction',
    components: {
        Layout
    },
    props:{},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>
<style  scoped>
.contentImg{
    width: 100%;
    float: left;
}
</style>